
const savedTransitionDuration = useLocalStorage('transition-duration', 300);

export default function useMotion() {
  return savedTransitionDuration;
}